// import { UserOutlined } from '@ant-design/icons';
// import { Avatar, Badge, Button, Modal, Tabs, Typography } from 'antd';
import { Tooltip } from 'antd';
// import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
// import { motion } from 'framer-motion';
// import { updateFollow } from '../../../services/School';
import VerificationBadge from 'assets/Icons/verificationBadge';
import ZebralearnBlackLogo from 'assets/Icons/ZebralearnBlackLogo';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
// import ZebralearnLogoIcon from 'assets/Header/Zebralearn/ZebralearnLogoIcon';
import {
  BiChevronLeft,
  BiLogoLinkedinSquare,
  BiPhone,
  BiPlus,
  BiUpload,
} from 'react-icons/bi';

import PaginatedBookSlider from '@/components/BookComp/PaginatedBookSlider';
import PaginatedCoursesSlider from '@/components/Courses/PaginatedCoursesSlider';
import { getLoginToken } from '@/components/shared/getToken';
import PaginatedStoreSlider from '@/components/StoreComp/PaginatedStoreSlider';

// import { useRecoilState } from 'recoil';
// import { /* authModalControl, */ tokenUpdate } from '../../../atoms/authModalControl';
// import AuthorCards from '../../../components/AuthorComp/AuthorCard';
// import AuthorBooks from '../../../components/AuthorComp/AuthorCard/AuthorBooks';
// import AuthorCourse from '../../../components/AuthorComp/AuthorCard/AuthorCourse';
// import AuthorSchools from '../../../components/AuthorComp/AuthorCard/AuthorSchools';
// import LiveCardAuthor from '../../../components/AuthorComp/AuthorCard/LiveCard';
// import { formatCount } from '../../../components/ResourcesPage/ResourcesPage/ChaptersPage';
// import ButtonDefault, {
//   ButtonVariants,
// } from '../../../components/shared/basic/button';
import { pageTitle } from '../../../components/shared/basic/customHead';
// import { ShouldRender } from '../../../components/shared/basic/ShouldRender';
import { formateErrorObject } from '../../../components/shared/formateErrorObject';
// import { getLoginToken } from '../../../components/shared/getToken';
// import CustomLoader from '../../../components/shared/Loading';
import { notify } from '../../../components/shared/notify';
// import appwriteService from '../../../config/appwrite';
import {
  followAuthorV2,
  getAuthorProfileV2,
  IAuthorDetails,
} from '../../../services/Author';

interface Props {
  userName: string;
}

const AuthorPage: React.FC<Props> = ({ userName }) => {
  const [authorData, setAuthorData] = useState<IAuthorDetails | null>(null);
  // const [isModalVisible, setIsModalVisible] = useState(false);
  const [isFollowing, setIsFollowing] = useState(false);
  const [, setFollowCount] = useState(0);
  // const [isTokenChanged, setIsTokenChanged] = useRecoilState(tokenUpdate);
  // const [loggedIn, setLoggedIn] = useState<boolean>(false);
  // const [, setVisible] = useRecoilState(authModalControl);
  // const [isLoading, setIsLoading] = useState(true);
  const [token, setToken] = useState('');
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(window.location.href);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };
  const fetchData = async () => {
    try {
      const token = await getLoginToken();
      setToken(token as string);
    } catch (error) {
      console.error('Error fetching token:', error);
    }
  };

  // const screens = useBreakpoint();
  const router = useRouter();

  const fetchAuthorData = async () => {
    try {
      // setIsLoading(true);
      const response = await getAuthorProfileV2(userName);
      const data = response?.data;

      if (data) {
        setAuthorData(data);
        // setIsFollowing(data.followed || false);
        // setFollowCount(data.followers?.length || 0);
      }
    } catch (error: any) {
      const message = formateErrorObject(error);

      notify(message, 'error');
      if (error?.response?.status === 404) {
        router.replace('/404');
      }
    } finally {
      // setIsLoading(false);
    }
  };

  // const handleCancel = () => {
  //   setIsModalVisible(false);
  // };

  const handleFollow = async () => {
    try {
      await followAuthorV2(userName);
    } catch (error) {
      console.error('Error :', error);
      // Revert on error
      setIsFollowing((prev) => !prev);
      setFollowCount((count) => (!isFollowing ? count - 1 : count + 1));
    }
  };

  const toggleFollow = () => {
    const newState = !isFollowing;

    setIsFollowing(newState);
    setFollowCount((count) => (newState ? count + 1 : count - 1));

    handleFollow();
  };

  useEffect(() => {
    fetchAuthorData();
  }, [userName]);

  // useEffect(() => {
  //   fetchData();
  //   if (isTokenChanged) {
  //     setIsTokenChanged(false);
  //   }
  // }, [isTokenChanged]);

  // const items = [
  //   {
  //     key: '1',
  //     label: (
  //       <div className='w-full flex justify-center text-center'>Books</div>
  //     ),
  //     children: <AuthorBooks authorId={authorData?.zl_Uid as string} />,
  //   },
  //   {
  //     key: '2',
  //     label: (
  //       <div className='w-full flex justify-center text-center'>Courses</div>
  //     ),
  //     children: <AuthorCourse authorId={authorData?.zl_Uid as string} />,
  //   },
  //   {
  //     key: '3',
  //     label: <div className='w-full flex justify-center text-center'>Live</div>,
  //     children: (
  //       <LiveCardAuthor authorId={authorData?.zl_Uid as string} token={token} />
  //     ),
  //   },
  //   {
  //     key: '4',
  //     label: (
  //       <div className='w-full flex justify-center text-center px-4'>
  //         Schools
  //       </div>
  //     ),
  //     children: <AuthorSchools authorId={authorData?.zl_Uid as string} />,
  //   },
  // ];

  // useEffect(() => {
  //   const fetchLoggedInStatus = async () => {
  //     const loggedInStatus = await appwriteService.isLoggedIn();
  //     setLoggedIn(loggedInStatus);
  //   };
  //   fetchLoggedInStatus();
  //   if (isTokenChanged) {
  //     setIsTokenChanged(false);
  //   }
  // }, [appwriteService.account, isTokenChanged]);
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <Head>
        <title>{pageTitle(authorData?.name || 'Author Page')}</title>
      </Head>
      <div>
        <div className='h-[48px] lg:hidden flex items-center justify-between px-0 lg:px-[48px]'>
          <div className='flex items-center gap-3'>
            <BiChevronLeft className='w-7 h-7 text-white' />
            <p className='xxs:text-lg text-sm text-white font-semibold'>
              Profile
            </p>
          </div>
          <Tooltip
            placement='bottom'
            title={isCopied ? 'Copied!' : 'Copy Link'}
            trigger={['click']}
          >
            <BiUpload
              onClick={handleCopy}
              className='w-7 h-7 text-white me-[14px] cursor-pointer'
            />
          </Tooltip>
        </div>
        <div className='w-full aspect-[4/1] px-0 lg:px-[48px] relative'>
          <Image
            src={
              authorData?.backgroundImage
                ? `${process.env.NEXT_PUBLIC_API_READER_URL}/api/v2/author-profile/background-image/${userName}`
                : ''
            }
            alt={`${authorData?.name}'s banner`}
            className='object-cover aspect-[4/1] w-full'
            width={1344}
            height={336}
          />
          <Tooltip
            placement='bottom'
            title={isCopied ? 'Copied!' : 'Copy Link'}
            trigger={['click']}
          >
            <div
              onClick={handleCopy}
              className='w-10 h-10 rounded-full bg-white absolute top-[16px] lg:right-[calc(16px+48px)] right-[calc(16px)] lg:flex hidden items-center justify-center hover:scale-[1.02] active:scale-[1] transition-all cursor-pointer'
            >
              <BiUpload className='w-5 h-5 text-black' />
            </div>
          </Tooltip>
        </div>
        <div className='aspect-square md:w-[120px] w-[64px] relative z-20 md:-mt-[80px] -mt-[20px] rounded-full lg:mx-[calc(48px+30px)] xxs:mx-[calc(20px)] mx-[16px] lg:mb-6 xxs:mb-4 mb-3'>
          <Image
            src={
              authorData?.avatar
                ? `${process.env.NEXT_PUBLIC_API_READER_URL}/api/v2/authors/avatar/${userName}`
                : ''
            }
            alt={`${authorData?.name}'s avatar`}
            className='object-cover aspect-square w-[120px] rounded-full   border-[4px] border-black  '
            width={120}
            height={120}
          />
        </div>
        <div className='lg:mx-[calc(48px+30px)] xxs:mx-[calc(20px)] mx-[16px]'>
          <div className='flex items-center gap-2.5 xxs:mb-3 mb-0'>
            <p className='lg:text-[32px]/[28px] xxs:text-[28px]/[26px] text-xl font-bold text-white'>
              {authorData?.name || 'Vibha Kagzi'}
            </p>
            {authorData?.isVerified && (
              <VerificationBadge className='xxs:w-[26px] w-[22px] xxs:h-[26px] h-[22px]' />
            )}
          </div>
          <p className='lg:text-[18px]/[26px] xxs:text-[16px]/[24px] text-xs text-grayZl-600 xxs:mb-2 mb-1'>
            {authorData?.bio ||
              'Author | Educator in Modern Learning? Turning knowledge into clear, usable insights.'}
          </p>
          {authorData?.isBestSellingAuthor && (
            <div className='flex items-center gap-1.5 bg-grayZl-500 rounded-full xxs:h-[24px] h-[20px]  px-3 w-fit xxs:mb-5 mb-3'>
              <ZebralearnBlackLogo className='xxs:w-4 xxs:h-4 w-[14px] h-[14px]' />
              <p className='xxs:text-xs/[100%] text-[10px]/[100%] text-black font-medium'>
                Bestselling Author
              </p>
            </div>
          )}
          <div className='flex items-end lg:gap-3 xxs:gap-2 gap-[7px]'>
            <p className='lg:text-[27px]/[28px] xxs:text-[24px]/[28px] text-[20px]/[28px] text-grayZl-500 font-bold'>
              {authorData?.learners || '0'}
            </p>
            <p className='xxs:text-[18px]/[28px] text-xs text-grayZl-500'>
              Learners
            </p>
          </div>
          <div className='flex items-center xxs:flex-nowrap flex-wrap gap-[18px] xxs:gap-[18px] gap-y-3 lg:mt-7 mt-5'>
            <button
              onClick={toggleFollow}
              className='flex items-center justify-center gap-1.5 xxs:h-10 h-[32px] px-6 xxs:w-auto w-[calc(50%-9px)] bg-gradient-to-r from-[#F03906] to-[#9E200E] rounded-lg hover:scale-[1.02] active:scale-[1] transition-all'
            >
              {!isFollowing && (
                <BiPlus className='xxs:w-5 w-[16px] xxs:h-5 h-[16px] text-white' />
              )}
              <p className='xxs:text-base text-sm text-white'>
                {isFollowing ? 'Following' : 'Follow'}
              </p>
            </button>
            <button
              onClick={() => {
                if (authorData?.bookacallLink) {
                  window.open(authorData.bookacallLink, '_blank');
                }
              }}
              className='flex items-center justify-center gap-1.5 xxs:h-10 h-[32px] px-6 xxs:w-auto w-[calc(50%-9px)] border border-white rounded-lg hover:scale-[1.02] active:scale-[1] transition-all'
            >
              <BiPhone className='xxs:w-5 w-[16px] xxs:h-5 h-[16px] text-white' />
              <p className='xxs:text-base text-sm text-white line-clamp-1'>
                Book a Call
              </p>
            </button>
            <button
              onClick={() => {
                if (authorData?.linkedinLink) {
                  window.open(authorData.linkedinLink, '_blank');
                }
              }}
              className='flex items-center justify-center gap-1.5 xxs:h-10 h-[32px] px-6 xxs:w-auto w-full bg-[#0A66C2] rounded-lg hover:scale-[1.02] active:scale-[1] transition-all'
            >
              <BiLogoLinkedinSquare className='xxs:w-5 w-[16px] xxs:h-5 h-[16px] text-white' />
              <p className='xxs:text-base text-sm text-white'>Message</p>
            </button>
          </div>
          <div className='mt-[26px]'>
            <p className='uppercase text-grayZl-600 lg:text-xl text-sm font-bold lg:mb-3 mb-2'>
              Author.
            </p>
            <p className='text-base'>
              {authorData?.longDescription ||
                'Carbonite web goalkeeper 👽 gloves are 🦾 ergonomically designed to give easy fit. 💗'}
            </p>
          </div>
        </div>
        <div className='space-y-[36px] mt-[36px]'>
          <PaginatedBookSlider
            categoryId={null}
            categoryName='Books'
            authorId={userName as string}
          />
          <PaginatedCoursesSlider
            token={token}
            categoryId={null}
            categoryName='All'
            name='Courses'
            authorId={userName as string}
          />
          <PaginatedStoreSlider authorId={userName as string} />
        </div>
      </div>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { userName } = context.params as { userName: string };

  return {
    props: {
      userName,
    },
  };
};

export default AuthorPage;
